module.exports = __webpack_public_path__ + "img/poorter_hotel-074.f5002fb6.jpg";